import React, { useState } from 'react';
import styles from './style.module.css';

import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function InputField(props) {
  const {
    // mandatory props
    name,
    type,
    // recommendation 1
    label,
    defaultValue = '',
    // recommendation 2
    value = null,
    setInputValue,
    // optional props
    className,
    required,
    disabled = false,
    placeholder,
    autoFocus,
    min,
    max,
    loginForm,
    pattern,
    title = "Don't input any symbol",
    alertMessage,
    // alertMessage = 'Tidak boleh kosong, harus diisi',
  } = props;

  const classes = [styles.root, className, !label && styles.noLabel]
    .filter(Boolean)
    .join(' ');

  const [inputLocalValue, setInputLocalValue] = useState(
    defaultValue ? defaultValue : ''
  );

  function assignValue(val, locVal) {
    return val ? val : locVal;
  }

  return (
    <div className={classes}>
      {label && (
        <>
          <label htmlFor={name}>
            {label} <span className={styles.doubleColonMobile}> :</span>
          </label>
          <span className={styles.doubleColon}>:</span>
        </>
      )}
      {type === 'longtext' ? (
        <textarea
          name={name}
          id={name}
          cols="5"
          rows="5"
          required={required}
          // value={value ? value : defaultValue ? defaultValue : inputLocalValue}
          // value={value ? value : inputLocalValue}
          value={assignValue(value, inputLocalValue)}
          placeholder={placeholder}
          onChange={(e) =>
            setInputValue
              ? setInputValue(e.target.value)
              : setInputLocalValue(e.target.value)
          }
          disabled={disabled}
          autoFocus={autoFocus}
          pattern={pattern}
          title={title}
        ></textarea>
      ) : (
        <input
          className={loginForm && styles.loginForm}
          type={type}
          name={name}
          id={name}
          required={required}
          // value={value ? value : defaultValue ? defaultValue : inputLocalValue}
          // value={value ? value : inputLocalValue}
          value={assignValue(value, inputLocalValue)}
          placeholder={placeholder}
          onChange={(e) =>
            setInputValue
              ? setInputValue(e.target.value)
              : setInputLocalValue(e.target.value)
          }
          disabled={disabled}
          autoFocus={autoFocus}
          min={min}
          max={max}
          pattern={pattern}
          title={title}
        />
      )}
      {required && alertMessage && (
        <>
          <div></div>
          <div></div>
          <div className={styles.inputAlert}>
            <FontAwesomeIcon icon={faTriangleExclamation} />
            {` `}&nbsp;
            <span>{alertMessage}</span>
          </div>
        </>
      )}
    </div>
  );
}
